module.exports = "/dark-x42d0057aed0fe49f5b4279680c23834c.svg";